<div class="kt-portlet">
	<kt-portlet-header [sticky]="false" [title]="'Restocks'" [class]="'kt-portlet__head--lg'">
		<ng-container ktPortletTools>
			<div class="restocks__tools">
				<button
					*ngIf="data?.has_camera"
					type="button"
					class="restocks__camera-toggle"
					[class.restocks__camera-toggle--on]="showCamera"
					[attr.aria-pressed]="showCamera"
					(click)="onShowCameraChange(!showCamera)">
					<mat-icon class="restocks__camera-toggle-icon" aria-hidden="true">{{ showCamera ? 'visibility' : 'visibility_off' }}</mat-icon>
					BrewVision
				</button>
				<div class="restocks__range" role="group" aria-label="Time range">
					<button
						*ngFor="let option of ranges"
						type="button"
						class="restocks__range-option"
						[class.restocks__range-option--active]="option.value === range"
						[attr.aria-pressed]="option.value === range"
						(click)="onRangeChange(option.value)">
						{{ option.label }}
					</button>
				</div>
			</div>
		</ng-container>
	</kt-portlet-header>
	<div class="kt-portlet__body">
		<div class="restocks">
			<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

			<div class="restocks__notice" role="alert" *ngIf="loadError">{{ loadError }}</div>

			<ng-container *ngIf="data">
				<div class="restocks__notice" role="status" *ngIf="data.camera_unavailable && showCamera">
					BrewVision readings could not be loaded right now. The restocks logged on the machine are all listed.
				</div>

				<section class="restocks__visit" *ngFor="let visit of visits; trackBy: trackVisit">
					<header class="restocks__visit-head">
						<span class="restocks__visit-time">{{ formatVisitTime(visit.at) }}</span>
						<span class="restocks__visit-count">{{ canisterCount(visit) }}</span>
					</header>
					<ul class="restocks__rows">
						<li class="restocks__row" *ngFor="let restock of visit.restocks">
							<span class="restocks__canister">{{ canisterName(restock) }}</span>

							<ng-container *ngIf="restock.machine; else unlogged">
								<span class="restocks__logged" [matTooltip]="gramsTooltip(restock.machine.grams_added)">
									{{ describeMachineRestock(restock.machine) }}
								</span>
								<span
									class="restocks__note"
									*ngIf="note(restock) as cameraNote"
									[ngClass]="'restocks__note--' + cameraNote.kind"
									[matTooltip]="restock.camera ? gramsTooltip(restock.camera.grams_added) : ''">
BrewVision {{ cameraNote.text }}
								</span>
							</ng-container>

							<ng-template #unlogged>
								<span class="restocks__unlogged">
									Not logged on the machine. BrewVision {{ unloggedRestockText(restock) }}.
								</span>
							</ng-template>
						</li>
					</ul>
				</section>

				<p class="restocks__empty" *ngIf="!visits.length">No restocks in the last {{ rangeLabel() }}.</p>

				<p class="restocks__footnote" *ngIf="visits.length">
					Times are the machine's local time.
					<ng-container *ngIf="cameraShown">BrewVision shows its amount when it saw the same canister filled within {{ data.match_window_minutes }} minutes.</ng-container>
				</p>
			</ng-container>
		</div>
	</div>
</div>
